import { MakeCall } from './createMakeCall';
import { ListingPhoto } from './types/Listing';

export interface UpdateListingPhotoOptions {
  order: number[];
  rotate?: number;
}

const updateListingPhotosOrder =
  (makeCall: MakeCall) =>
  (listingId: number, { order, rotate }: UpdateListingPhotoOptions) =>
    makeCall<ListingPhoto[]>('PUT', `/api/v2/listing/${listingId}/photos`, {
      data: {
        order,
        ...(rotate ? { rotate } : {}),
      },
    });
export { updateListingPhotosOrder };
